import { BasketMode } from '../types/commons';

// TODO: This variable will be deleted as soon as the old edit modes are removed
export const MODIFICATION_MODES: BasketMode[] = ['modifyPrestations', 'modifyAppointment', 'modification'];
